import {
  createSimpleAxiosErrorNotification,
  createSimpleAxiosWarningNotification,
  createSimpleSuccessNotification,
  createErrorNotification,
  createWarningNotification,
} from "../common/notifications/notification";
import {apiService} from "../utils/serviceApi";
import {
  ADD_GAS_STATION,
  CLEAR_GAS_STATION_FOR_DETAILS,
  CLEAR_GAS_STATION_FOR_EDIT,
  GET_ALL_GAS_STATION_ZONES,
  GET_ALL_GAS_STATIONS_FOR_GS_ADMIN_OR_GS_MANAGER,
  GET_GAS_STATION_FOR_UPDATE,
  GET_GAS_STATION_LABEL_SUGGESTION,
  SET_LOADER,
  UPDATE_GAS_STATION,
} from "./types";
import i18next from "i18next";
import {NotificationManager} from "react-notifications";
import {colorMapOptions, dimmedMapOptions} from "../containers/parkingZone/marker";


export const getAllGasStations = (country) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  apiService
    .post(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/admin`, {country})
    .then((res) => {
      dispatch({
        type: GET_ALL_GAS_STATION_ZONES,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const addGasStation = (data, closeModal) => async (dispatch) => {
  apiService
    .postForm(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station`, data)
    .then((res) => {
      if (res.status < 300) {
        dispatch({
          type: ADD_GAS_STATION,
          payload: res.data,
        });
        createSimpleSuccessNotification();
        closeModal();
      } else {
        createSimpleAxiosWarningNotification(res);
      }
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
      console.log(e.response);
    });
};

export const editGasStation = (id, gasStation, closeModal) => (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  apiService
    .putForm(
      `${process.env.REACT_APP_SERVICE_URL}/api/gas-station/sysadmin/${id}`,
      gasStation
    )
    .then((res) => {
      dispatch({
        type: UPDATE_GAS_STATION,
        payload: res.data,
      });
      createSimpleSuccessNotification();
      closeModal();
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
      console.error(e.response);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const getGasStationForUpdate = (id) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  apiService
    .get(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/forUpdate/${id}`)
    .then((res) => {
      dispatch({
        type: GET_GAS_STATION_FOR_UPDATE,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const getGasStationLabelSuggestion = (clientId) => async (dispatch) => {

  const url = `${process.env.REACT_APP_SERVICE_URL}/api/gas-station/labelSuggestions/${clientId}`;

  dispatch({
    type: SET_LOADER,
    payload: true,
  });

  apiService
    .get(url)
    .then((res) => {
      dispatch({
        type: GET_GAS_STATION_LABEL_SUGGESTION,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.log('API Error:', e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const clearGasStationForDetails = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GAS_STATION_FOR_DETAILS,
  });
};

export const clearGasStationForEdit = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GAS_STATION_FOR_EDIT,
  });
};

export const getAllGasStationsForGSAdmin = (country) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  apiService
    .post(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/GSAdmin`, {country})
    .then((res) => {
      dispatch({
        type: GET_ALL_GAS_STATIONS_FOR_GS_ADMIN_OR_GS_MANAGER,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const geocodeAddressFetchFirstResult = async (geocoder, countryCode, formattedAddress) => {
  const response = await geocoder.geocode(
      {
        address: formattedAddress,
        region: countryCode
      });

  const firstResult = response?.results[0];
  const firstGeometry = firstResult?.geometry; // ignore other results atm
  return {firstResult, firstGeometry};
}

export const geocodeAddressSetMarker = async (map, geocoder, address, setMarker, doNotify:boolean = true) : Promise<void> => {
  const formattedAddress = `${address.street}, ${address.city} ${address.zipCode}, ${address.countryCode}`;

  geocodeAddressFetchFirstResult(geocoder, address.countryCode, formattedAddress)
      .then(({firstResult, firstGeometry}) => {
        if (firstGeometry) {
          if (firstResult.partial_match && doNotify) {
            createWarningNotification(i18next.t('EditParkingZoneModal.partialMatchLong'), i18next.t('EditParkingZoneModal.partialMatch'));
          }
          const lat = firstGeometry.location?.lat();
          const lng = firstGeometry.location?.lng();
          const streetAddress = firstResult.formatted_address;

          // sanity check for QA
          const countryComponent = firstResult.address_components.find((element) => element.types.includes("country"));
          const isLichtenstein = countryComponent.short_name === 'LI' && address.countryCode === 'CH';          
          if (countryComponent?.short_name !== address.countryCode && !isLichtenstein) {
            throw new Error(i18next.t('EditParkingZoneModal.countryCodeMismatch', {expectedCC: address.countryCode, actualCC: countryComponent?.short_name}));
          }

          map.fitBounds(firstGeometry.viewport);
          map.setZoom(map.getZoom() + 2); // zoom in a little bit closer
          map.setOptions(colorMapOptions);

          setMarker({
            center: { lat, lng }
          });

          doNotify && NotificationManager.success(
              i18next.t('EditParkingZoneModal.geocodingSuccessfulLong', {formattedAddress: formattedAddress, googleStreetAddress: streetAddress}),
              i18next.t('EditParkingZoneModal.geocodingSuccessful'),
              6000);

          // Optionally compare address parts with Google Maps result parts and offer to the user to fix some parts, e.g. zip code
        } else {
          map.setOptions(dimmedMapOptions);
          setMarker(null);

          doNotify && createErrorNotification(i18next.t('EditParkingZoneModal.geocodingUnsuccessfulLong'), i18next.t('EditParkingZoneModal.geocodingUnsuccessful'));
        }
      })
      .catch((error) => {
        map?.setOptions(dimmedMapOptions);
        setMarker(null);

        console.error(error);

        doNotify && createErrorNotification(
            i18next.t('EditParkingZoneModal.geocodingUnsuccessfulLong') + error.toString(),
            i18next.t('EditParkingZoneModal.geocodingUnsuccessful'));
      });
}
